import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { PaymentsService } from '../../services/payments.service';
import { StripeService } from '../../services/stripe.service';

@Component({
	selector: 'app-dispatch-add-card',
	templateUrl: './dispatch-add-card.component.html',
	styleUrls: ['./dispatch-add-card.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class DispatchAddCardComponent implements OnInit, OnDestroy {
	@Input() customer: any = [];
	@Output() newcarddata = new EventEmitter<any>();
	@ViewChild('stripeCardContainer') stripeCardContainer: ElementRef<HTMLDivElement>;
	paymentForm: UntypedFormGroup;
	result: any = [];
	sending = false;
	addingcard = false;
	stripeGatewayActive = false;
	useStripe = false;
	stripeUnconfigured = false;
	stripeMounted = false;
	stripePublishableKey = '';

	constructor(
		private paymentsService: PaymentsService,
		private fb: UntypedFormBuilder,
		private stripeService: StripeService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.paymentsService.getStripeClientConfig().subscribe((cfg: any) => {
			this.stripeGatewayActive = !!cfg?.requires_stripe_js;
			this.stripePublishableKey = cfg?.publishable_key || '';
			this.useStripe = this.stripeGatewayActive && this.stripePublishableKey !== '';
			this.stripeUnconfigured = this.stripeGatewayActive && this.stripePublishableKey === '';
			this.buildForm();
			if (this.useStripe) setTimeout(() => this.mountStripe(), 200);
		});
		this.buildForm();
	}

	ngOnDestroy(): void {
		if (this.useStripe) this.stripeService.unmountCardElement();
	}

	private buildForm(): void {
		const base: any = {
			debtorno: [this.customer?.debtorno, Validators.required],
			branchcode: [this.customer?.branchcode, Validators.required],
			name: [this.customer?.name, Validators.required]
		};
		this.paymentForm = this.fb.group({
			...base,
			ccnumber: ['', this.useStripe ? [] : [Validators.required]],
			expiry: ['', this.useStripe ? [] : [Validators.required]],
			cvv: ['', this.useStripe ? [] : [Validators.required]]
		});
	}

	private mountStripe(): void {
		if (!this.stripePublishableKey) return;
		const tryMount = (delay: number, attemptsLeft: number) => {
			setTimeout(() => {
				if (!this.useStripe || this.stripeMounted) return;
				const el = this.stripeCardContainer?.nativeElement;
				if (!el) {
					if (attemptsLeft > 0) tryMount(200, attemptsLeft - 1);
					return;
				}
				this.stripeService.init(this.stripePublishableKey).then(ok => {
					if (!ok || !this.useStripe) return;
					this.stripeService.mountCardElement(el).then(() => {
						this.stripeMounted = true;
						this.cdr.detectChanges();
					});
				});
			}, delay);
		};
		tryMount(100, 5);
	}

	toggleAddingCard(): void {
		this.addingcard = !this.addingcard;
	}

	addPaymentMethod(): void {
		if (this.useStripe) {
			if (!this.paymentForm.get('name')?.value?.trim() || !this.stripeMounted) {
				alert('Enter card holder name and card details.');
				return;
			}
			if (!this.stripeService.canCreatePaymentMethod()) {
				this.stripeMounted = false;
				this.cdr.detectChanges();
				alert('Secure card fields are not ready. Please wait for the form to load or refresh the page and try again.');
				return;
			}
			this.sending = true;
			this.stripeService.createPaymentMethod(this.paymentForm.get('name')?.value?.trim()).then(res => {
				if (res.error) {
					this.sending = false;
					if (!this.stripeService.canCreatePaymentMethod()) this.stripeMounted = false;
					this.cdr.detectChanges();
					alert(res.error);
					return;
				}
				const payload = { ...this.paymentForm.value, payment_method: res.paymentMethodId };
				this.paymentsService.addCreditCard(payload).subscribe((result: any) => {
					this.sending = false;
					if (!result.success) alert(result.message);
					else {
						this.result = result;
						this.addingcard = false;
						this.newcarddata.emit({ card: result, orderno: this.customer?.orderno });
					}
				});
			});
			return;
		}
		if (this.paymentForm.valid) {
			this.sending = true;
			this.paymentsService.addCreditCard(this.paymentForm.value).subscribe((result: any) => {
				this.sending = false;
				if (!result.success) alert(result.message);
				else {
					this.result = result;
					this.addingcard = false;
					this.newcarddata.emit({ card: result, orderno: this.customer?.orderno });
				}
			});
		}
	}
}
